<template>
  <div class="group-detail">
    <h1 class="common__main-title">A Tutor’s Personal Information register</h1>
    <div class="common__sub-title">
      <span>Details</span>
      <span class="common__sub-title-tag">Register New</span>
    </div>
    <div class="common__main-contener">
      <ValidationObserver ref="observer">
        <InputForm v-model="tutor" />
        <div class="d-flex justify-content-between">
          <b-button
            pill
            variant="secondary"
            :to="{name:'TutorList'}"
          >
            Back
          </b-button>
          <b-button
            pill
            variant="primary"
            @click="formValidate"
          >
            Confirm
          </b-button>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import InputForm from '@/components/parts/tutor/InputForm.vue';
import { ValidationObserver } from 'vee-validate';
import { Tutor } from '@/store/tutors/types';

export default Vue.extend({
  components: {
    InputForm,
    ValidationObserver,
  },

  data(): {
    tutor: Tutor|null,
    } {
    return {
      tutor: null,
    }
  },

  methods: {
    /* inputformのバリデーションを実行(veeValidate) */
    formValidate() {
      (this.$refs.observer as any).validate()
        .then((result: any) => {
          if (result) {
            this.gotoConfirm()
          }
        });
    },
    gotoConfirm() {
      this.$router.push({
        name: 'TutorAddConfirm',
        params: { editingTutor: JSON.stringify(this.tutor) },
      })
    },
  },
})
</script>

<style scoped>

.button-container {
  display: flex;
  justify-content: space-between;
}
</style>
